import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { Subject, takeUntil, timer } from 'rxjs';

@Component({
    selector: 'tun-create-new-playlist-to-add',
    templateUrl: './create-new-playlist-to-add.component.html',
    styleUrl: './create-new-playlist-to-add.component.scss',
    standalone: false
})
export class CreateNewPlaylistToAddComponent implements AfterViewInit, OnDestroy {
   // === ViewChildren === //
     @ViewChild('nameInput')
     nameInput: ElementRef;

     private _canReceiveFocus = false;
       @Input()
       public set canReceiveFocus(value: boolean){
         this._canReceiveFocus = value;
         this.focusIfPossible();
       }
       public get canReceiveFocus(){
         return this._canReceiveFocus;
       }

       private componentDestroyed$ = new Subject<boolean>();

       @Output() back = new EventEmitter<void>();
       @Output() createPlaylist = new EventEmitter<string>();

       onBack(){
         this.back.emit();
       }

       public currentName = "";
       onNameChange(name: string){
         this.currentName = name;
       }

       onCommitIfPossible(){
          if (this.currentName && this.currentName.length){
            this.onCommit();
          }
        }

       onCommit(){
        this.createPlaylist.emit(this.currentName);
       }

       ngOnDestroy() {
        this.componentDestroyed$.next(true);
        this.componentDestroyed$ = null;
      }

       private _initDone = false;
         private set initDone(value: boolean){
           this._initDone = value;
           this.focusIfPossible();

         }
         private get initDone(){
           return this._initDone;
         }
         private focusIfPossible(){
           if (this.initDone && this.canReceiveFocus){
             if (this.nameInput) {
               this.nameInput.nativeElement.focus();
             }
           }
         }

         ngAfterViewInit(): void {

           //we need to set the focus after the views animation has finished
           timer(100)
           .pipe(
             takeUntil(
               this.componentDestroyed$
             )
           )
           .subscribe(
             () => {
               this.initDone = true;
             }
           )
         }
}
